import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dollar-sign",
  "use": "dollar-sign-usage",
  "viewBox": "0 0 11 22",
  "content": "<symbol viewBox=\"0 0 11 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"dollar-sign\"><title>noun_1015774</title><path d=\"M2.881 7.333c0 1.215.967 2.2 2.16 2.2 2.503.002 4.625 1.872 4.986 4.392.361 2.521-1.148 4.93-3.545 5.66V22h-2.88v-2.415C1.464 18.936 0 16.936 0 14.667h2.881c0 1.215.967 2.2 2.16 2.2 1.194 0 2.161-.985 2.161-2.2 0-1.215-.967-2.2-2.16-2.2C2.54 12.465.418 10.595.057 8.075c-.362-2.521 1.147-4.93 3.544-5.66V0h2.881v2.415c2.136.649 3.6 2.649 3.601 4.918h-2.88c0-1.215-.968-2.2-2.161-2.2-1.194 0-2.161.985-2.161 2.2z\" fill-rule=\"nonzero\" fill=\"#FFBD00\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/dollar-sign.svg
// module id = 1544
// module chunks = 0